// Environment configuration helper
// This file helps manage different environment settings

class EnvironmentConfig {
  constructor() {
    // Get the current environment
    this.env = process.env.NODE_ENV || 'development';
    this.customEnv = process.env.REACT_APP_ENV;
    
    // Load environment variables
    this.apiUrl = process.env.REACT_APP_API_URL;
    this.wsUrl = process.env.REACT_APP_WS_URL;
  }

  // Get the API base URL
  getApiUrl() {
    if (this.apiUrl) {
      return this.apiUrl;
    }
    
    // Fallback URLs based on environment
    switch (this.customEnv || this.env) {
      case 'production':
        return 'https://caro-backend.xuantrung48.workers.dev';
      case 'staging':
        return 'https://caro-backend-staging.xuantrung48.workers.dev';
      default:
        return 'http://localhost:8787';
    }
  }

  // Get the WebSocket URL
  getWebSocketUrl() {
    if (this.wsUrl) {
      return this.wsUrl;
    }
    
    // Derive WebSocket URL from API URL
    const apiUrl = this.getApiUrl();
    return apiUrl.replace(/^https?:/, 'wss:');
  }

  // Check if we're in development mode
  isDevelopment() {
    return (this.customEnv || this.env) === 'development';
  }

  // Check if we're in production mode
  isProduction() {
    return (this.customEnv || this.env) === 'production';
  }

  // Check if we're in staging mode
  isStaging() {
    return (this.customEnv || this.env) === 'staging';
  }

  // Get environment name for display
  getEnvironmentName() {
    return this.customEnv || this.env;
  }

  // Get all configuration
  getConfig() {
    return {
      environment: this.getEnvironmentName(),
      apiUrl: this.getApiUrl(),
      webSocketUrl: this.getWebSocketUrl(),
      isDevelopment: this.isDevelopment(),
      isProduction: this.isProduction(),
      isStaging: this.isStaging()
    };
  }
}

// Create and export a singleton instance
const config = new EnvironmentConfig();

export default config;

// Export the class for testing purposes
export { EnvironmentConfig };
